import api from 'src/utils/api/core'

export function getSso (redirectUrl) {
  return api.get(`/sso?redirectUrl=${redirectUrl}`)
}
